export default (api) => ({
  getAll: transactionId => api.get(`/transfer-orders/transaction/${transactionId}`),
  resend: transferOrderId => api.post(`/transfer-orders/${transferOrderId}`),
  markDeclined: transferOrderId => api.post(`/transfer-orders/${transferOrderId}/mark-declined`),
  /**
    * @param {string} transferOrderId
    * @param {{ clearedAt?: string, returnedAt?: string }} data
    */
  updateDates: (transferOrderId, data) => api.patch(`/transfer-orders/${transferOrderId}`, data)
})
